import React from "react";
import { ISearchValue, SearchTypeEnum } from "@/components/YhPageHeader/Types";
import { YhPageHeader } from "@/components/YhPageHeader";
import useGlobalModel from "@/model/globalModel";
import { useAcctUnitModel } from "../acctUnitModel";
import Item from "antd/lib/list/Item";


export function PageHeader() {
    const { allShopDs, mdmBeDs } = useGlobalModel();
    const {
        searchParam,
        updateSearchParam,
        resetSearchParam,
        loadData
    } = useAcctUnitModel();

    const searchFields = [
        {
            type: SearchTypeEnum.Input,
            placeholder: "内部核算单位",
            fieldName: "name",
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "关联站点",
            fieldName: "shop",
            options: allShopDs
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "关联实体",
            fieldName: "bentity",
            options: mdmBeDs.map((item: any) => ({ ...item, value: item.id }))
        },
        {
            type: SearchTypeEnum.Select,
            placeholder: "状态",
            fieldName: "status",
            options: [{ label: "启用", value: 1 }, { label: "禁用", value: 0 }]
        }
    ]


    return (
        <YhPageHeader
            title="内部核算单位"
            size="small"

            searchValues={searchParam as ISearchValue}
            searchFields={searchFields}
            onChange={updateSearchParam}
            triggerSearch
            handleSearch={(val = {}) => loadData({ pageNum: 1 }, { ...searchParam, ...val })}
            handleReset={resetSearchParam}
        />
    );
}